<template>
  <div class="batch-card-additional-information-icon">
    <div
      :id="'batch-card-additional-information-' + index"
      class="batch-card-additional-information-icon__regular"
    >
      <svg-loader
        :src="'/static/images/icon-' + additionalState + '.svg'"
        :class="additionalColor"
      />
      <md-tooltip
        md-delay="100"
        md-direction="bottom"
      >
        {{
          additionalName
        }}
      </md-tooltip>
    </div>
  </div>
</template>

<script>
import strings from '@/strings'

export default {
  name: 'BatchCardAdditionalInformationIcon',
  props: {
    index: {
      type: Number,
      default: 0
    },
    type: {
      type: String
    }
  },
  computed: {
    additionalState: function () {
      return strings.additionalInformationStatus.find(
        (x) => x.type === this.type
      ).state
    },
    additionalName: function () {
      return strings.additionalInformationStatus.find(
        (x) => x.type === this.type
      ).name
    },
    additionalColor: function () {
      return strings.additionalInformationStatus.find(
        (x) => x.type === this.type
      ).color
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-additional-information-icon {
  flex: 20%;

  &__regular {
    width: 30px;
    height: 30px;
    position: relative;
    float: right;

    .md-icon {
      border-radius: 10%;
      padding: 4px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
